module.exports = __webpack_public_path__ + "static/media/place-footer.f84e0221.svg";